"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
var _slicedToArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.regexp.split");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var quarter_options = [{
  label: 'Q1',
  value: '01',
  months: [1, 2, 3]
}, {
  label: 'Q2',
  value: '02',
  months: [4, 5, 6]
}, {
  label: 'Q3',
  value: '03',
  months: [7, 8, 9]
}, {
  label: 'Q4',
  value: '04',
  months: [10, 11, 12]
}];
var _default = exports.default = {
  name: 'QuarterDate',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var yearValue = this.value ? this.value.split('-')[0] : ''; // 年份
    var quarterValue = this.value ? this.value.split('-')[1] : ''; // 季度
    var _this$getTodayQuarter = this.getTodayQuarter(),
      _this$getTodayQuarter2 = (0, _slicedToArray2.default)(_this$getTodayQuarter, 2),
      todayYear = _this$getTodayQuarter2[0],
      todayQuarter = _this$getTodayQuarter2[1]; // 当前季度
    return {
      quarter_options: quarter_options,
      yearValue: yearValue || todayYear,
      quarterValue: quarterValue,
      todayYear: todayYear,
      todayQuarter: todayQuarter
    };
  },
  methods: {
    getTodayQuarter: function getTodayQuarter() {
      var todayYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth() + 1;
      var target = quarter_options.find(function (item) {
        return item.months.includes(parseInt(currentMonth));
      });
      return [todayYear, target.value];
    },
    clickItem: function clickItem(value) {
      this.quarterValue = value;
      this.$emit('change', "".concat(this.yearValue, "-").concat(this.quarterValue));
    },
    preYear: function preYear() {
      this.yearValue = this.yearValue * 1 - 1;
      this.quarterValue = '';
    },
    nextYear: function nextYear() {
      var v = this.yearValue * 1 + 1;
      this.yearValue = v > this.todayYear ? this.todayYear : v;
      this.quarterValue = '';
    }
  }
};